var _circle, _path, _path2, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAusMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 16.5,
    stroke: "#0464B2",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 2C9.3873 2 2 9.3873 2 18.5C2 27.6127 9.3873 35 18.5 35C27.6127 35 35 27.6127 35 18.5C35 13.2022 32.5033 8.48764 28.6222 5.46868",
    stroke: "#0464B2",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1785 10.3431C17.1448 9.20055 19.5618 9.22052 21.5097 10.3954C23.4385 11.5942 24.6108 13.7338 24.5999 16.0353C24.555 18.3217 23.298 20.471 21.7267 22.1325C20.8199 23.0958 19.8054 23.9475 18.704 24.6704C18.5905 24.736 18.4663 24.7799 18.3373 24.8C18.2132 24.7947 18.0924 24.758 17.9857 24.6933C16.3042 23.6071 14.829 22.2206 13.6311 20.6006C12.6287 19.2482 12.0593 17.6144 12 15.921C11.9987 13.615 13.2121 11.4856 15.1785 10.3431ZM16.3146 16.8754C16.6453 17.6909 17.4261 18.2228 18.2923 18.2228C18.8597 18.2268 19.4052 17.9995 19.8072 17.5915C20.2091 17.1835 20.4342 16.6287 20.4322 16.0506C20.4352 15.1683 19.9157 14.3712 19.1164 14.0314C18.317 13.6916 17.3954 13.8762 16.7818 14.499C16.1683 15.1218 15.9838 16.06 16.3146 16.8754Z",
    fill: "#0464B2"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 18.2988,
    cy: 26.5999,
    rx: 4.5,
    ry: 0.9,
    fill: "#0464B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAusMapIcon);
export default __webpack_public_path__ + "static/media/ausMapIcon.9a404b1a279e495c0ca27c231edc653d.svg";
export { ForwardRef as ReactComponent };